import { CheckupTag } from '@companion-professional/dctypes';

// This is a central place to store configuration details for the application.  Currently, these are hardcoded, but in
// the future we could these could be dependent on the environment that the application is running in.

// API URLS
const API_BASE_URL = '/api/v1';
const API_V3_INT_BASE_URL = '/api/v3/int';
export const SUPPORTS_FUZZY_PATIENT_CLIENT_SEARCH_URL = `${API_V3_INT_BASE_URL}/supports_fuzzy_patient_client_search`;
export const FUZZY_PATIENT_CLIENT_SEARCH_URL = `${API_V3_INT_BASE_URL}/fuzzy_patient_client_search`;
const API_V3_VIDEO_BASE_URL = '/api/v3/video';
export const VIDEO_DOWNLOAD_URL = `${API_V3_VIDEO_BASE_URL}/download_url`;
export const LOGIN_URL = `${API_BASE_URL}/login`;
export const CHANGE_LOGIN_CLINIC_URL = `${API_BASE_URL}/change_login_clinic`;
export const CHANGE_PASSWORD_URL = `${API_BASE_URL}/change_password`;
export const CHECKUP_REQUESTS_URL = `${API_BASE_URL}/checkup_requests`;
export const CHECKUP_REQUESTS_FOR_PET_URL = `${API_BASE_URL}/checkup_requests_for_pet`;
export const CHECKUP_REQUEST_URL = `${API_BASE_URL}/checkup_request`;
export const CHECKUP_LOCATION_TAG_URL = `${API_BASE_URL}/checkup_location`;
export const ARCHIVE_CHECKUP_REQUEST_URL = `${API_BASE_URL}/checkup_requests`;
export const UPDATE_PET_INFO_URL = `${API_BASE_URL}/pet_info`;
export const UPDATE_PET_NAME_URL = `${API_BASE_URL}/pet_name`;
export const GET_PLAYBACK_URL = `${API_BASE_URL}/playback_url`;
export const GET_PETS_URL = `${API_BASE_URL}/pets`;
export const GET_PET_URL = `${API_BASE_URL}/pet`;
export const ARCHIVE_PET_URL = `${API_BASE_URL}/pet`;
export const GET_PET_STATS_URL = `${API_BASE_URL}/pet_stats`;
export const GET_USER_CLINICS_URL = `${API_BASE_URL}/clinics`;
export const GET_SURVEYS_FOR_CLINIC_URL = `${API_BASE_URL}/clinic_surveys`;
export const GET_FULL_SURVEY_URL = `${API_BASE_URL}/clinic_survey`;
export const ADD_SURVEY_ANSWERS_URL = `${API_BASE_URL}/survey_answers`;
export const UPDATE_SURVEY_ANSWERS_URL = `${API_BASE_URL}/survey_answers`;
export const GET_BASE_CHECKUP_URL = `${API_BASE_URL}/base_checkup_url`;
export const GET_SURVEY_ANSWERS_URL = `${API_BASE_URL}/survey_answers`;
export const GET_CURRENT_CLINIC_URL = `${API_BASE_URL}/current_clinic`;
export const GET_CURRENT_CLINIC_USERS_URL = `${API_BASE_URL}/clinic_users`;
export const GET_ACTIVE_CHECKUP_ITEM_ML_URL = `${API_BASE_URL}/checkup_ml_results`;
export const GET_ML_RESULTS_FOR_CHECKUP_URL = `${API_BASE_URL}/ml_for_checkup`;
export const GENERATE_ANIMATED_GIF_URLS_URL = `${API_BASE_URL}/generate_animated_gif_urls`;

// Item Review URLS
const ITEM_REVIEW_BASE_URL = `${API_BASE_URL}/item_review`;
export const GET_ITEMS_TO_REVIEW_FOR_SURVEY_URL = `${ITEM_REVIEW_BASE_URL}/item_survey`;
export const GET_ITEM_REVIEW_SURVEYS_URL = `${ITEM_REVIEW_BASE_URL}/item_surveys`;
export const GET_ITEMS_TO_REVIEW_CHECKUP_SURVEYS_URL = `${ITEM_REVIEW_BASE_URL}/checkup_surveys`;
export const ADD_ITEM_REVIEW_ANSWERS_URL = `${ITEM_REVIEW_BASE_URL}/answers`;

// Checkup Review URLS
const CHECKUP_REVIEW_BASE_URL = `${API_BASE_URL}/checkup_review`;
export const GET_CHECKUPS_WITH_UNLINKED_VIDEOS_URL = `${CHECKUP_REVIEW_BASE_URL}/with_unlinked_videos`;

// USER_SELECTABLE_LOCATION_TAGS are the tags that a user can select when creating a checkup.
export const USER_SELECTABLE_LOCATION_TAGS: CheckupTag[] = ['in_home', 'in_clinic'];

// ML_ANALYSIS_FAQ_URL is the URL to the FAQ page for ML analysis results.  This can be edited here:
// https://www.notion.so/companionlabs/Computer-Vision-Analysis-FAQ-21b29875074980de8c76f7482575e742
export const ML_ANALYSIS_FAQ_URL =
  'https://companionlabs.notion.site/Computer-Vision-Analysis-FAQ-21b29875074980de8c76f7482575e742';
